export const CMS_SETTINGS_RESET_STATE = 'CMS_SETTINGS_RESET_STATE';
export const CMS_SETTINGS_CURRENT_ITEM = 'CMS_SETTINGS_CURRENT_ITEM';

export const CMS_SETTINGS_REQUEST_LOADING = 'CMS_SETTINGS_REQUEST_LOADING';
export const CMS_SETTINGS_REQUEST_SUCCESS = 'CMS_SETTINGS_REQUEST_SUCCESS';
export const CMS_SETTINGS_REQUEST_FAILED = 'CMS_SETTINGS_REQUEST_FAILED';

export const CMS_SETTINGS_CURRENT_ACTION = 'CMS_SETTINGS_CURRENT_ACTION';
export const CMS_SETTINGS_RESET_ACTION = 'CMS_SETTINGS_RESET_ACTION';